<template>
  <div>
    <Header v-if="$route.meta.header != 1" />
    <router-view />
  </div>
</template>

<script>
import Header from "../src/components/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@import "./styles/global.css";
#app {
  min-height: 100vh;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
}
</style>
